import Swiper from "swiper";


// owl
$('.brands-carousel').owlCarousel({
    loop: true,
    autoplay: true,
    autoplayTimeout: 2000,
    stagePadding: 50,
    margin: 10,
    autoWidth: true,
    items: 20,
    dots: false
});


// footer animace
const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add('reveal');
        }
    });
}, { threshold: 0.5 });
document.querySelectorAll('.reveal-section').forEach(section => {
    observer.observe(section);
});


// com46 text slideshow
document.addEventListener("DOMContentLoaded", () => {
    const texts = document.querySelectorAll("#com46-text-slideshow .com46-text");
    let index = 0;

    function showNextText() {
        texts.forEach((text, i) => {
            text.classList.toggle("active", i === index);
        });

        index = (index + 1) % texts.length;
    }

    showNextText(); // Zobrazíme první text
    setInterval(showNextText, 2500); // Přepínání po 3 sekundách
});

// swiper about us + expertise


let swiper2;

function initSwiper2() {
    const isLargeScreen = window.innerWidth;

    if (isLargeScreen > 1279) {
        if (swiper2) swiper2.destroy(true, true);
        swiper2 = null;
    } else if ( isLargeScreen < 1279 && isLargeScreen > 767) {
        if (swiper2) swiper2.destroy(true, true);
        swiper2 = new Swiper(".mySwiper2", {
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            speed: 2000,
            loop: true,
            autoHeight: false,
            slidesPerView: 1.75, // Změna pro menší obrazovky
            spaceBetween: 15 // Změna pro menší obrazovky
        });
    } else if (isLargeScreen < 767) {
        if (swiper2) swiper2.destroy(true, true);
        swiper2 = new Swiper(".mySwiper2", {
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            speed: 2000,
            loop: true,
            autoHeight: false,
            slidesPerView: 1.25, // Změna pro menší obrazovky
            spaceBetween: 15 // Změna pro menší obrazovky
        });
    }
}

// Spuštění na začátku
window.addEventListener("load", initSwiper2);
// A při změně velikosti
window.addEventListener("resize", () => {
    initSwiper2();
});

//swiper work section

let swiper;

function initSwiper() {
    const isLargeScreen = window.innerWidth;

    if (isLargeScreen > 1279) {
        if (swiper) swiper.destroy(true, true);
            swiper = new Swiper(".mySwiper", {
                pagination: {
                    el: ".swiper-pagination",
                    type: "progressbar",
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                speed: 2000,
                loop: true,
                autoHeight: false,
                slidesPerView: 1,
                spaceBetween: 0
            });
    } else if ( isLargeScreen < 1279 && isLargeScreen > 767) {
        if (swiper) swiper.destroy(true, true);
        swiper = new Swiper(".mySwiper", {
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            speed: 2000,
            loop: true,
            autoHeight: false,
            slidesPerView: 1.75, // Změna pro menší obrazovky
            spaceBetween: 15 // Změna pro menší obrazovky
        });
    } else if (isLargeScreen < 767) {
        if (swiper) swiper.destroy(true, true);
        swiper = new Swiper(".mySwiper", {
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            speed: 2000,
            loop: true,
            autoHeight: false,
            slidesPerView: 1.25, // Změna pro menší obrazovky
            spaceBetween: 15 // Změna pro menší obrazovky
        });
    }

    // if (isLargeScreen) {
    //     if (swiper) swiper.destroy(true, true);
    //     swiper = new Swiper(".mySwiper", {
    //         pagination: {
    //             el: ".swiper-pagination",
    //             type: "progressbar",
    //         },
    //         navigation: {
    //             nextEl: ".swiper-button-next",
    //             prevEl: ".swiper-button-prev",
    //         },
    //         autoplay: {
    //             delay: 3000,
    //             disableOnInteraction: false,
    //         },
    //         speed: 2000,
    //         loop: true,
    //         autoHeight: false,
    //         slidesPerView: 1,
    //         spaceBetween: 0
    //     });
    // } else {
    //     if (swiper) swiper.destroy(true, true);
    //     swiper = new Swiper(".mySwiper", {
    //         pagination: {
    //             el: ".swiper-pagination",
    //             type: "progressbar",
    //         },
    //         navigation: {
    //             nextEl: ".swiper-button-next",
    //             prevEl: ".swiper-button-prev",
    //         },
    //         autoplay: {
    //             delay: 3000,
    //             disableOnInteraction: false,
    //         },
    //         speed: 2000,
    //         loop: true,
    //         autoHeight: false,
    //         slidesPerView: 2.5, // Změna pro menší obrazovky
    //         spaceBetween: 15 // Změna pro menší obrazovky
    //     });
    // }
}

// Spuštění na začátku
window.addEventListener("load", initSwiper);
// A při změně velikosti
window.addEventListener("resize", () => {
    initSwiper();
});

// var swiper = new Swiper(".mySwiper", {
//     pagination: {
//         el: ".swiper-pagination",
//         type: "progressbar",
//     },
//     navigation: {
//         nextEl: ".swiper-button-next",
//         prevEl: ".swiper-button-prev",
//     },
//     autoplay: {
//         delay: 3000, // Čas mezi slidy (ms)
//         disableOnInteraction: false, // Nezastaví se po interakci
//     },
//     speed: 2000,
//     loop: true, // Opakování slideru
//     autoHeight: false
// });